/**
 * 三包理赔的表单验证处理
 * @author zjs
 * @time 2017-09-21
 */
export default {
    data () {
        // 非空的判断
        var isNoEmpty = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入'))
            } else {
                callback()
            }
        }
        return {
            formRules: {
                work_time: [{ required: true, trigger: 'blur' }],
                lipei_time: [{ required: true, trigger: 'blur' }],
                'customer.customer_name': [{ required: true, trigger: 'blur' }],
                'customer.customer_contact': [{ required: true, trigger: 'blur' }],
                piaoju_no: [{ required: true, trigger: 'blur' }],
                // 'customer.customer_address': [{ required: true, trigger: 'blur' }],
                'customer.customer_tel': [{ validator: isNoEmpty, required: true, trigger: 'blur' }],
                sender: [{ required: true, trigger: 'blur' }],
                jingying_id: [{ validator: isNoEmpty, required: true, trigger: 'blur' }],
                pici: [{ required: true, trigger: 'blur' }],
                guanlian_transaction_no: [{ required: true, trigger: 'blur' }],
                lipei_manner: [{ validator: isNoEmpty, required: true, trigger: 'blur' }],
            }
        }
    },
    methods: {
        /**
         * 验证货品信息
         * @param  {[Array]} arr [货品列表]
         * @param  {[String,number]} lipei_manner [理赔的方式]
         */
        validateProduct (arr, lipei) {
            let msg = '' // 提示的信息
            let index = -1 // 记录有问题的行
            for (let i in arr) {
                let row = arr[i]
                // let bool = false
                // 判断是否选择货品
                if (!row.product || !row.product.product_id) {
                    msg += '"货品"'
                } else {
                    // 货品编码验证
                    if (!row.product.product_cai || row.product.product_cai.length < 1) {
                        msg += '"货品编码"'
                    } else if (!row.product.product_name || row.product.product_name.length < 1) { // 货品名称
                        msg += '"货品名称"'
                    }
                }
                // 2018-04-10 第31批，修改成胎号必须是下拉选择选择－－－start
                // 是否填写了胎号
                // if (!row.taihao || !row.taihao.taihao_no) {
                //     msg += '"胎号"'
                // } else {
                //     // 胎号验证
                //     if (!row.taihao.taihao_no || row.taihao.taihao_no.length < 1) {
                //         msg += '"胎号"'
                //     } 
                // }
                // 三包胎号控制是否为必填项 39批 2018.8.15
                console.log("taihao===>", this.userInfo)
                if (this.userInfo && this.userInfo.sanbao_taihao_show) {
                    console.log("taihao_id ===>", row.taihao)
                    if (!row.taihao || !row.taihao.taihao_id) {
                        msg += '"胎号"'
                    }
                }
                /* ----  2018-04-10 end---- */
                // 鉴定人
                if (!row.jiandingren) {
                    msg += '"鉴定人"'
                }
                // 是否填写了病象
                if (!row.symptom || !row.symptom.bingxiang_id) {
                    msg += '"病象"'
                }
                // 余花 
                // 余花 2017-11-09 邮件通知 改为非必填
                // if (!row.yuhua) {
                //     msg += '"余花"'
                // }
                // 理赔类型
                if (!row.lipei_type) {
                    msg += '"理赔类型"'
                }
                // 理赔的赔偿判断
                msg += this.validatorMoney(row, lipei)
                if (msg.length > 0) {
                    index = i
                    break;
                }
            }
            if (index >= 0) {
                msg = '第' + parseInt(parseInt(index) + 1) + '行还未选择\n' + msg
            } else {
                msg = this.validatorTaihao(arr)
            }
            return msg
        },
        /**
         * 胎号重复的判定
         * @return {[type]} [description]
         */
        validatorTaihao (arr) {
            let msg = ''
            let diffArr = [] // 不同胎号的存储
            for (let i in arr) {
                let row = arr[i]
                if (row.taihao) {
                    let no = String(row.taihao.taihao_no).replace(/(^\s*)|(\s*$)/g,"")
                    // 对比diff中的值
                    for (let j in diffArr) {
                        if (no === diffArr[j]) {
                            msg = '第' + parseInt(parseInt(i) + 1) + '行 与 第' + parseInt(parseInt(j) + 1) + '行 的胎号重复'
                            break;
                        }
                    }
                    diffArr.push(no)
                }
            }
            // 2017-11-02 这里修改成，重复胎号只给提示，仍然可以提交（这个是罗老师给子薇说的）
            if (msg.length > 0) {
                this.$notify({
                    title: '胎号提示',
                    message: msg,
                    type: 'warning'
                })
            }
            return ''
        },
        /**
         * 理赔的赔偿判断
         * @param  {[type]} lipei_manner [description]
         * @return {[type]}              [description]
         */
        validatorMoney (row, lipei) {
            let msg = ''
            if (String(lipei) === '1') { // 赔胎时 贴损金额、贴损类型必填
                if (String(row.tiesun_amount).length < 1) {
                    msg = '"贴损金额"' 
                }
                if (!row.tiesun_type) {
                    msg += '"贴损类型"'
                }
            } else if (String(lipei) === '2') { // 赔钱时 理赔金额必填
                if (String(row.lipei_amount).length < 1) {
                    msg = '"理赔金额"' 
                }
            }
            // 2017-11-02 这里修改成，重复胎号只给提示，仍然可以提交（这个是罗老师给子薇说的）
            if (msg.length > 0) {
                this.$notify({
                    title: '胎号提示',
                    message: msg,
                    type: 'warning'
                })
            }
            return ''
        }
    }
}